import { required } from '@vuelidate/validators';
<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12 md:col-12">
      <div class="card card-w-title">
        <HeaderBar createButton="true" @new-event="openCreateDialog" title="دسته بندی" />
        <Divider type="dashed" />
        <!-- Table Section Begin -->
        <div v-if="!!categories.length && !loading.page">
          <DataTable ref="dt" :value="categories" dataKey="id" class="overflow-hidden border-round-2xl shadow-1 mt-5" responsiveLayout="scroll">
            <Column field="title" header="عنوان" headerStyle="width:14%; min-width:10rem;">
              <template #body="slotProps">
                <span class="p-column-title">عنوان</span>
                {{ slotProps.data.title }}
              </template>
            </Column>
            <Column header="تصویر" headerStyle="width:14%; min-width:10rem;">
              <template #body="slotProps">
                <span class="p-column-title">تصویر</span>
                <img :src="'https://api.koome.net/' + slotProps.data.picture" width="25" />
              </template>
            </Column>
            <Column field="description" header="توضیحات" headerStyle="width:14%; min-width:8rem;">
              <template #body="slotProps">
                <span class="p-column-title">توضیحات</span>
                {{ slotProps.data.description }}
              </template>
            </Column>
            <Column header="عملیات" headerStyle="min-width:10rem;">
              <template #body="slotProps">
                <Button icon="pi pi-pencil" v-tooltip.top="'ویرایش'" class="p-button-rounded p-button-success ml-2" @click="editProduct(slotProps.data)" />
                <Button icon="pi pi-trash" v-tooltip.top="'حذف'" class="p-button-rounded p-button-warning mt-2" @click="confirmDeleteProduct(slotProps.data)" />
                <Button @click="changeActiveStatus(slotProps.data)" type="button" :icon="`pi pi-${slotProps.data.isActive ? 'check' : 'times'}`" v-tooltip.top="'وضعیت'" :class="`p-button-rounded p-button-${slotProps.data.isActive ? 'success' : 'danger'} mr-2`"></Button>
              </template>
            </Column>
          </DataTable>
          <Paginator :rows="pageSize" :totalRecords="totalCount" @page="changePaging($event)"></Paginator>
        </div>
        <div v-if="!categories.length && !loading.page" class="w-full text-center my-3">
          <InlineMessage>موردی وجود ندارد</InlineMessage>
        </div>
        <Loading v-if="loading.page" />
        <!-- Table Section End -->
        <!-- Edit Dialog Section Begin -->
        <Dialog @hide="editPicture = null" v-model:visible="categoryDialog" :style="{ width: '450px' }" header="ویرایش" :modal="true" class="p-fluid">
          <div v-if="product.picture">
            <img :src="'https://api.koome.net/' + product.picture" width="50" class="mt-0 mx-auto mb-5 block shadow-2" />
            <div class="text-center">
              <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mb-2" @click="product.picture = null" />
            </div>
          </div>
          <div v-else>
            <div v-if="!editPicture" class="text-center">
              <label for="pictureUploaderId" class="w-full justify-content-center cursor-pointer">
                <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
              </label>
              <input id="pictureUploaderId" @change="onUpload($event, 'edit')" accept="image/png, image/jpeg" type="file" hidden />
            </div>
            <div class="text-center relative" @click="editPicture = null" v-else>
              <img role="presentation" :alt="editPicture.name" :src="imageConvertBlob(editPicture)" class="w-20rem h-10rem border-1 border-round-3xl" />
              <div class="field remove-picture">
                <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="editPicture = null" />
              </div>
            </div>
          </div>
          <!-- ************************ -->
          <div class="field">
            <label for="name">عنوان</label>
            <InputText
              id="name"
              v-model.trim="product.title"
              @blur="v$.product.title.$touch"
              @input="v$.product.title.$touch"
              required="true"
              autofocus
              :class="
                ({ 'p-invalid': submitted && !product.title },
                {
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.product.title.$error,
                })
              "
            />
            <small v-if="v$.product.title.$invalid && v$.product.title.$dirty" ref="password_error_message" class="text-red-500">
              {{ v$.product.title.required.$message }}
            </small>
            <!-- <small class="p-invalid" v-if="submitted && !product.title">Name is required.</small> -->
          </div>
          <div class="field">
            <label for="description">توضیحات</label>
            <Textarea
              id="description"
              v-model="product.description"
              required="true"
              @blur="v$.product.description.$touch"
              @input="v$.product.description.$touch"
              rows="3"
              cols="20"
              :class="{
                'border-red-500 hover:border-red-500 focus:shadow-none': v$.product.description.$error,
              }"
            />
            <small v-if="v$.product.description.$invalid && v$.product.description.$dirty" ref="password_error_message" class="text-red-500">
              {{ v$.product.description.required.$message }}
            </small>
          </div>
          <template #footer>
            <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
            <Button :disabled="!product.description || !product.title" label="ویرایش" icon="pi pi-check" class="p-button-text" @click="updateCategory" />
          </template>
        </Dialog>
        <!-- Edit Dialog Section Ended -->
        <!-- Delete Dialog Section Begin -->
        <Dialog v-model:visible="deleteCategoryDialog" :style="{ width: '450px' }" header="حذف" :modal="true">
          <div class="flex flex-column align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
            <span v-if="product" class="mt-3">آیا مطمئن هستید؟</span>
          </div>
          <template #footer>
            <div class="text-center">
              <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="deleteCategoryDialog = false" />
              <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="removeCategory" />
            </div>
          </template>
        </Dialog>
        <!-- New Dialog Section Ended -->
        <Dialog v-model:visible="newCategoryDialog" :style="{ width: '600px' }" header="ایجاد دسته بندی" :modal="true" class="p-fluid">
          <div class="flex align-items-center justify-content-center flex-column">
            <div v-if="!picture">
              <label for="fileUploaderId" class="w-full justify-content-center cursor-pointer">
                <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
              </label>
              <input id="fileUploaderId" @change="onUpload($event, 'add')" accept="image/png, image/jpeg" type="file" hidden />
            </div>
            <div class="text-center relative" v-else>
              <img role="presentation" :alt="picture.name" :src="imageConvertBlob(picture)" class="w-20rem h-10rem border-1 border-round-3xl" />
              <div class="field remove-picture">
                <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3" @click="picture = null" />
              </div>
            </div>
          </div>
          <div class="field">
            <span>
              <label for="catTitle">عنوان:</label>
              <InputText
                id="catTitle"
                type="text"
                v-model="category.title"
                @blur="v$.category.title.$touch"
                @input="v$.category.title.$touch"
                :class="{
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.category.title.$error,
                }"
              />
              <small v-if="v$.category.title.$invalid && v$.category.title.$dirty" ref="password_error_message" class="text-red-500">
                {{ v$.category.title.required.$message }}
              </small>
            </span>
          </div>
          <div class="field">
            <span>
              <label for="catDescription">توضیحات:</label>
              <Textarea
                v-model="category.description"
                @blur="v$.category.description.$touch"
                @input="v$.category.description.$touch"
                id="catDescription"
                :autoResize="true"
                rows="5"
                cols="30"
                :class="{
                  'border-red-500 hover:border-red-500 focus:shadow-none': v$.category.description.$error,
                }"
              />
              <small v-if="v$.category.description.$invalid && v$.category.description.$dirty" ref="password_error_message" class="text-red-500">
                {{ v$.category.description.required.$message }}
              </small>
            </span>
          </div>
          <template #footer>
            <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="newCategoryDialog = false" />
            <Button :disabled="v$.category.title.$invalid || v$.category.description.$invalid || !picture" type="submit" class="p-button-text" label="ایجاد" icon="pi pi-check" @click="createCategory" :loading="loading[create]" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  name: "categoryPage",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      category: {
        title: "",
        description: "",
      },
      picture: null,
      svgUploaded: "",
      loading: {
        page: false,
        create: false,
        update: false,
        remove: false,
      },
      categories: [],
      product: {},
      submitted: false,
      editPicture: null,
      totalCount: 1,
      pageSize: 10,
      categoryDialog: false,
      deleteCategoryDialog: false,
      newCategoryDialog: false,
    };
  },
  validations: {
    category: {
      title: {
        required,
      },
      description: {
        required,
      },
    },
  },
  validations() {
    return {
      category: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        description: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
      product: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        description: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
    };
  },
  methods: {
    //******* Api methods begin *******//
    async getListCategory(page = 1) {
      this.loading.page = true;
      const { status, data } = await this.axios({ method: "get", url: `Category/GetAll?Title=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.totalCount = data.totalCount;
      this.categories = [...data.data];
      this.loading.page = false;
    },
    async createCategory() {
      const config = { header: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("picture", this.picture);
      formData.append("title", this.category.title);
      formData.append("description", this.category.description);
      const { status, data } = await this.axios({ method: "post", url: "Category/Create", data: formData, config });
      status == 200 && this.getListCategory();
      this.category.title, (this.category.description = "");
      this.showToast(status);
      this.newCategoryDialog = false;
      this.picture = null;
    },
    async removeCategory() {
      const { status, data } = await this.axios({ method: "delete", url: `Category/Delete/${this.product.id}` });
      if (status === 200) {
        this.product = {};
      }
      this.getListCategory();
      this.deleteCategoryDialog = false;
      this.showToast(status);
    },
    async updateCategory() {
      const config = { header: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("picture", !!this.editPicture ? this.editPicture : null);
      formData.append("title", this.product.title);
      formData.append("description", this.product.description);
      const { status, data } = await this.axios({ method: "put", url: `Category/Update/${this.product.id}`, data: formData, config });
      if (status == 200) {
        this.product = {};
        this.editPicture = null;
        this.getListCategory();
      }
      this.hideDialog();
      this.showToast(status);
    },
    async changeActiveStatus(selected) {
      const { status, data } = await this.axios({ method: "patch", url: `Category/ChangeActiveStatus/${selected.id}` });
      this.showToast(status);
      (status == 200 || status == 201) &&
        this.categories.map((_category) => {
          _category.id == selected.id ? (_category.isActive = !selected.isActive) : false;
        });
    },
    //******* Api methods end *******//
    changePaging(e) {
      this.getListCategory(++e.page);
    },
    onUpload(event, status) {
      if (event.target.files[0].type === "image/jpeg" || event.target.files[0].type === "image/png") {
        this.editPicture = null;
        status == "add" ? (this.picture = event.target.files[0]) : (this.editPicture = event.target.files[0]);
      } else {
        this.$toast.add({ severity: "error", summary: "خطا", detail: "فرمت وارد شده باید jpeg یا png باشد", life: 3000 });
      }
    },
    openCreateDialog() {
      this.newCategoryDialog = true;
      this.category = {
        title: "",
        description: "",
      };
      this.picture = null;
    },
    editProduct(product) {
      this.product = { ...product };
      this.categoryDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteCategoryDialog = true;
    },
    hideDialog() {
      this.categoryDialog = false;
      this.editPicture = null;
      this.submitted = false;
    },
    imageConvertBlob(picture) {
      return URL.createObjectURL(picture);
    },
  },
  created() {
    this.getListCategory();
  },
};
</script>

<style lang="scss">
.file-uploader {
  width: auto;
  margin: 0;
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-items: center;
  -align: bottom;
  text-averticallign: center;
  overflow: hidden;
  position: relative;
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;

  &:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 black;
    outline: 0 none;
    outline-offset: 0;
  }
}

.remove-picture {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    transition-delay: all 0.8s ease-in-out;
    visibility: hidden;
  }

  &:hover {
    i {
      visibility: visible;
    }
  }
}
</style>
